import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import styled, {css} from 'styled-components'

export const StyledCardWrapper = styled.div(
    ({theme: {spacing}}) => css`
        display: grid;
        grid-template-columns: 64px 1fr;
        column-gap: ${spacing * 3}px;
        align-items: start;
        width: 100%;
        & .show-on-hover {
            opacity: 0;
            transition: opacity 0.15s ease-in-out;
        }

        & .hide-on-hover {
            opacity: 1;
            transition: opacity 0.15s ease-in-out;
        }

        &:hover {
            & .show-on-hover {
                opacity: 1;
            }
            & .hide-on-hover {
                opacity: 0;
            }
        }
    `
)

export const StyledItemTextWrapper = styled(Flexbox)(
    ({theme: {typography, palette}}) => css`
        overflow: hidden;
        color: ${palette.neutral['900']};
        & > h4 {
            width: 100%;
            overflow: hidden;
            text-overflow: ellipsis;
            font-weight: 500;
        }

        & > p {
            ${typography.textSm};
        }
    `
)
export const StyledImagePlaceholderBox = styled.div(
    ({theme: {palette, opacities}}) => css`
        position: relative;
        background-color: ${palette.neutral['100']};
        height: 64px;
        border-radius: 8px;
        border: 1px solid ${palette.neutral.black}${opacities[20]};

        & > svg {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            fill: ${palette.neutral['600']};
        }
    `
)

export const StyledImageContainer = styled.div(
    () => css`
        position: relative;
        width: 100%;
        height: 64px;
    `
)
export const StyledEditIconContainer = styled.div(
    ({theme: {palette, opacities, shadows}}) => css`
        width: 100%;
        height: 64px;
        position: absolute;
        inset: 0;
        border-radius: 8px;
        background: ${palette.neutral.black}${opacities[60]};
        box-shadow: ${shadows.xs};

        & svg {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            fill: ${palette.neutral.white};
        }
    `
)
export const StyledAlertText = styled.p(
    ({theme: {typography, palette, spacing}}) => css`
        display: flex;
        gap: ${spacing * 1.5}px;
        ${typography.textSm};
        color: ${palette.danger['600']};
    `
)
